import React, {useEffect, useState} from "react";
import {createTheme, MenuItem, Select, ThemeProvider} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {IAppState} from "../../store/models";
import {IShelvesCategoryTreeChildDto, StoreParamTypesDto} from "../../dtos/flyer";
import {makeStyles} from "@mui/styles";
import {isEmpty} from 'lodash';
import {
    changeCategoriesSelectionForShelvesScreen,
    getShelvesData, getStoreData
} from "../../store/actionsCreator/shelvesScreenActionsCreator";
import {useMobileOrientation} from "react-device-detect";
import {toggleShelfPromoDetailsPopup} from "../../store/actionsCreator/shelfPromoActionCreator";
import {setAddToMyListOneItemData} from "../../store/actionsCreator/addToMyListOneItemActionsCreator";
import tinycolor from "tinycolor2";
import {StoreProjectDto} from "../../dtos/siteDto";
import {useHistory, useParams} from "react-router-dom";
import createCache from "@emotion/cache";
import rtlPlugin from 'stylis-plugin-rtl';
import {prefixer} from 'stylis';
import {CacheProvider} from "@emotion/react";

const useStyles = makeStyles(() => ({
    categorySelect: (props: any) => ({
        direction: props.direction,
        fontFamily: props.fontFamily,
        height: `30px`,
        width: `100%`,
        textAlign: 'start',
        backgroundColor: props.isMainCategories ? `#ffffff!important` : `#5892CA!important`,
        border: `none`,
        color: props.isMainCategories ? `${props.fontsGuiColor}!important` : `#ffffff!important`,
        '& > .MuiOutlinedInput-notchedOutline': {
            border: 'none'
        },
        '& > .MuiSvgIcon-root': {
            color: props.isMainCategories ? `${props.fontsGuiColor}!important` : `#ffffff!important`,
        },
        '& > .MuiSelect-select': {
            padding: `4px 10px`
        }
    }),
    selected: {
        backgroundColor: `#bbdefb!important`,
    },
    // rootMenuItem: {
    //     '&:hover':{
    //         backgroundColor: theme.palette ? theme.palette.primary.dark : `blue`
    //     }
    // },
}));

interface Props {
    isMainCategories: boolean;
}

const themeRtl = createTheme({
    direction: 'rtl', // Both here and <body dir="rtl">
});

const themeLtr = createTheme({
    direction: 'rtl', // Both here and <body dir="rtl">
});

// Create rtl cache
const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

export const ShelvesCategorySelect: React.FC<Props> = ({
                                                           isMainCategories
                                                       }) => {
    const {
        accountName,
        categoryLVL1Caption = "",
        categoryLVL3Caption = ""
    } = useParams<StoreParamTypesDto>();
    let history = useHistory();
    const urlSearchParams = new URLSearchParams(history.location.search);
    const allSearchParams = Object.fromEntries(urlSearchParams.entries());
    const {isLandscape} = useMobileOrientation();
    const dispatch = useDispatch();
    const storeGlobalData = useSelector<IAppState, StoreProjectDto | null>((state) => state.storeData);
    const {shelvesScreen, addToMyListOneItemData} = useSelector((state: IAppState) => state);
    const storeData = shelvesScreen.data;
    const flyerBasic = useSelector((state: IAppState) => state.flyerBranchBasic.data);
    const settingsForStore = storeGlobalData?.isFromFlyer ? flyerBasic : storeData?.storeSetting;
    const isLightGuiColor = tinycolor(settingsForStore?.primaryColorRgb || "#C32E43").isLight();
    const fontsGuiColor = settingsForStore?.fontsColorRgb || "#000000";
    const isHebrewStyle = settingsForStore?.dir?.toLowerCase() === "rtl";


    const [selectedMainCategory, setSelectedCategory] = useState<IShelvesCategoryTreeChildDto>({});
    const [selectedSecondaryCategory, setSelectedSecondaryCategory] = useState<IShelvesCategoryTreeChildDto>({});
    const [localStateMainCategories, setLocalStateMainCategories] = useState<IShelvesCategoryTreeChildDto[] | undefined>([]);
    const [localStateSecondaryCategoriesFromSelectedMainCategory, setLocalStateSecondaryCategoriesFromSelectedMainCategory] = useState<IShelvesCategoryTreeChildDto[] | undefined>([]);


    const stylesProperties = {
        direction: settingsForStore?.dir?.toLowerCase() || "ltr",
        primaryColor: settingsForStore?.primaryColorRgb || "#C32E43",
        fontFamily: settingsForStore?.font?.toLowerCase() || "roboto",
        isMainCategories: isMainCategories,
        isLightGuiColor: isLightGuiColor,
        fontsGuiColor: fontsGuiColor
    }
    const classes = useStyles(stylesProperties);
    useEffect(() => {
        // if(MAIN_CATEGORIES){
        //     MAIN_CATEGORIES.forEach((key: any) => {
        //         if(key.isSelected){
        //             setSelectedCategory(key);
        //         }
        //     })
        // }
        if (shelvesScreen.data?.categoryTree) {
            setLocalStateMainCategories(shelvesScreen.data?.categoryTree?.length ? shelvesScreen.data?.categoryTree : []);
        }
    }, [shelvesScreen]);

    useEffect(() => {
        if (localStateMainCategories) {
            localStateMainCategories.forEach((mainCategory: IShelvesCategoryTreeChildDto) => {
                if (mainCategory.isSelected) {
                    setSelectedCategory(mainCategory);
                }
            })
        }
    }, [localStateMainCategories]);

    useEffect(() => {
        if (localStateSecondaryCategoriesFromSelectedMainCategory) {
            const isSomeOfSecondaryCategoriesAlreadySelected = localStateSecondaryCategoriesFromSelectedMainCategory?.find((secondaryCategory: IShelvesCategoryTreeChildDto) => {
                if (secondaryCategory.isSelected) {
                    return secondaryCategory;
                }
            })
            if (!isSomeOfSecondaryCategoriesAlreadySelected && localStateSecondaryCategoriesFromSelectedMainCategory?.length) {
                onChangeSecondaryEvent();
            } else {
                if (isSomeOfSecondaryCategoriesAlreadySelected) {
                    setSelectedSecondaryCategory(isSomeOfSecondaryCategoriesAlreadySelected);
                }
            }
        }
    }, [localStateSecondaryCategoriesFromSelectedMainCategory])

    useEffect(() => {
        if (!isEmpty(selectedMainCategory) && shelvesScreen.data?.categoryTree) {
            if (selectedMainCategory.isSelected) {
                setLocalStateSecondaryCategoriesFromSelectedMainCategory(selectedMainCategory.childCategories);
            }
        }
    }, [selectedMainCategory]);

    const onChangeEvent = (event: any) => {
        if (localStateMainCategories) {
            const newLocalStateMainCategories = [...localStateMainCategories];
            newLocalStateMainCategories.forEach((mainCategory: IShelvesCategoryTreeChildDto) => {
                mainCategory.isSelected = mainCategory.id === event.target.value;
            })
            dispatch(changeCategoriesSelectionForShelvesScreen(newLocalStateMainCategories))
        }
    }

    const onChangeSecondaryEvent = (event?: any) => {
        if (localStateSecondaryCategoriesFromSelectedMainCategory?.length) {
            const customizeStateForSecondaryCategories = [...localStateSecondaryCategoriesFromSelectedMainCategory];
            let newStateForSecondaryCategories = customizeStateForSecondaryCategories.map((secondaryCategory: IShelvesCategoryTreeChildDto, index) => {
                if (index === 0) {
                    secondaryCategory = {
                        ...secondaryCategory,
                        isSelected: true,
                    }
                } else {
                    secondaryCategory = {
                        ...secondaryCategory,
                        isSelected: false,
                    }
                }
                return secondaryCategory;
            });
            if (event) {
                newStateForSecondaryCategories = customizeStateForSecondaryCategories.map((secondaryCategory: IShelvesCategoryTreeChildDto) => {
                    if (event.target.value === secondaryCategory.id) {
                        secondaryCategory = {
                            ...secondaryCategory,
                            isSelected: true,
                        }
                    } else {
                        secondaryCategory = {
                            ...secondaryCategory,
                            isSelected: false,
                        }
                    }
                    return secondaryCategory;
                })
            }

            const selectedCategory = newStateForSecondaryCategories.find((secondaryCategory: IShelvesCategoryTreeChildDto) => {
                if (secondaryCategory.isSelected) {
                    return secondaryCategory;
                }
            });
            if (settingsForStore && selectedCategory && selectedCategory.id) {
                setLocalStateSecondaryCategoriesFromSelectedMainCategory(newStateForSecondaryCategories);
                dispatch(toggleShelfPromoDetailsPopup(false));
                if (Boolean(addToMyListOneItemData.data)) {
                    dispatch(setAddToMyListOneItemData(null));
                }
                if (storeGlobalData?.isFromFlyer) {
                    dispatch(getShelvesData(
                        selectedCategory.id,
                        document.getElementById('storeIframe')?.offsetHeight!,
                        document.getElementById('storeIframe')?.offsetWidth!,
                        isLandscape,
                        settingsForStore?.id,
                        true));
                } else {

                    const urlSearchParams = new URLSearchParams(history.location.search);
                    const allSearchParams = Object.fromEntries(urlSearchParams.entries());

                    dispatch(getStoreData(
                        accountName,
                        document.getElementById('storeIframe')?.offsetHeight!,
                        document.getElementById('storeIframe')?.offsetWidth!,
                        isLandscape,
                        categoryLVL1Caption,
                        selectedCategory.caption || "",
                        categoryLVL3Caption,
                        false,
                        2,
                        allSearchParams.StoreSetting,
                        allSearchParams.LanguageCulture,
                    ));
                }
            }
        }
    }

    if (isMainCategories) {
        return (
            <>
                {
                    isHebrewStyle &&
                    <CacheProvider value={cacheRtl}>
                        <ThemeProvider theme={isHebrewStyle ? themeRtl : themeLtr}>
                            <Select
                                value={isEmpty(selectedMainCategory) ? '' : selectedMainCategory.id}
                                onChange={onChangeEvent}
                                displayEmpty
                                // dir={settingsForStore?.dir?.toLowerCase() || "ltr"}
                                className={classes.categorySelect}
                                sx={{
                                    width: `100%`,
                                    height: `32px`,
                                    border: `1px solid #888888`,
                                    textAlign: 'start',
                                    '& legend': {display: 'none'},
                                    '& fieldset': {
                                        top: 0,
                                        border: `none`,
                                    },
                                    '& > .MuiSelect-select': {
                                        padding: `8px`,
                                        textAlign: 'start'
                                    }
                                }}

                                // disableUnderline
                                // inputProps={{ 'aria-label': 'Without label' }}
                                MenuProps={{
                                    MenuListProps: {
                                        sx: {
                                            "& .MuiMenuItem-root": {
                                                minHeight: `auto`,
                                                textAlign: 'start',
                                            },
                                            "& .MuiMenuItem-root.Mui-selected": {
                                                backgroundColor: "#7FA2BF66",
                                            },
                                        }
                                    }
                                }}
                            >
                                {
                                    shelvesScreen.data?.categoryTree?.map((mainCategory: IShelvesCategoryTreeChildDto) => {
                                        if(allSearchParams.isCaptive === "true"){
                                            if(mainCategory.isSelected){
                                                return (
                                                    <MenuItem
                                                        dir={isHebrewStyle ? 'rtl' : 'ltr'}
                                                        key={mainCategory.id}
                                                        value={mainCategory.id}
                                                        disabled={!(mainCategory.childCategories && mainCategory.childCategories.length > 0)}
                                                    >
                                                        {mainCategory.caption}
                                                    </MenuItem>
                                                )
                                            }
                                        } else {
                                            return (
                                                <MenuItem
                                                    dir={isHebrewStyle ? 'rtl' : 'ltr'}
                                                    key={mainCategory.id}
                                                    value={mainCategory.id}
                                                    disabled={!(mainCategory.childCategories && mainCategory.childCategories.length > 0)}
                                                >
                                                    {mainCategory.caption}
                                                </MenuItem>
                                            )
                                        }
                                    })
                                }
                            </Select>
                        </ThemeProvider>
                    </CacheProvider>
                }
                {
                    !isHebrewStyle &&
                    <Select
                        value={isEmpty(selectedMainCategory) ? '' : selectedMainCategory.id}
                        onChange={onChangeEvent}
                        displayEmpty
                        // dir={settingsForStore?.dir?.toLowerCase() || "ltr"}
                        className={classes.categorySelect}
                        sx={{
                            width: `100%`,
                            height: `32px`,
                            border: `1px solid #888888`,
                            textAlign: 'start',
                            '& legend': {display: 'none'},
                            '& fieldset': {
                                top: 0,
                                border: `none`,
                            },
                            '& > .MuiSelect-select': {
                                padding: `8px`,
                                textAlign: 'start'
                            }
                        }}

                        // disableUnderline
                        // inputProps={{ 'aria-label': 'Without label' }}
                        MenuProps={{
                            MenuListProps: {
                                sx: {
                                    "& .MuiMenuItem-root": {
                                        minHeight: `auto`,
                                        textAlign: 'start',
                                    },
                                    "& .MuiMenuItem-root.Mui-selected": {
                                        backgroundColor: "#7FA2BF66",
                                    },
                                }
                            }
                        }}
                    >
                        {
                            shelvesScreen.data?.categoryTree?.map((mainCategory: IShelvesCategoryTreeChildDto) => {
                                if(allSearchParams.isCaptive === "true"){
                                    if(mainCategory.isSelected){
                                        return (
                                            <MenuItem
                                                dir={isHebrewStyle ? 'rtl' : 'ltr'}
                                                key={mainCategory.id}
                                                value={mainCategory.id}
                                                disabled={!(mainCategory.childCategories && mainCategory.childCategories.length > 0)}
                                            >
                                                {mainCategory.caption}
                                            </MenuItem>
                                        )
                                    }
                                } else {
                                    return (
                                        <MenuItem
                                            dir={isHebrewStyle ? 'rtl' : 'ltr'}
                                            key={mainCategory.id}
                                            value={mainCategory.id}
                                            disabled={!(mainCategory.childCategories && mainCategory.childCategories.length > 0)}
                                        >
                                            {mainCategory.caption}
                                        </MenuItem>
                                    )
                                }
                            })
                        }
                    </Select>
                }
            </>
        )

    } else {
        return (
            <>
                {
                    isHebrewStyle &&
                    <CacheProvider value={cacheRtl}>
                        <ThemeProvider theme={isHebrewStyle ? themeRtl : themeLtr}>
                            <Select
                                // value={_.isEmpty(selectedSecondaryCategory) ? '' : selectedSecondaryCategory.id}
                                value={isEmpty(selectedSecondaryCategory) ? '' : selectedSecondaryCategory.id}
                                onChange={onChangeSecondaryEvent}
                                displayEmpty
                                // dir={settingsForStore?.dir?.toLowerCase() || "ltr"}
                                className={classes.categorySelect}
                                sx={{
                                    width: `100%`,
                                    height: `32px`,
                                    border: `1px solid #888888`,
                                    textAlign: 'start',
                                    '& legend': {display: 'none'},
                                    '& fieldset': {
                                        top: 0,
                                        border: `none`,
                                    },
                                    '& > .MuiSelect-select': {
                                        padding: `8px`,
                                        textAlign: 'start'
                                    }
                                }}

                                MenuProps={{
                                    MenuListProps: {
                                        sx: {
                                            "& .MuiMenuItem-root": {
                                                minHeight: `auto`,
                                                textAlign: 'start',
                                            },
                                            "& .MuiMenuItem-root.Mui-selected": {
                                                backgroundColor: "#7FA2BF66",
                                            },
                                        }
                                    },

                                }}
                                // disableUnderline
                                // inputProps={{ 'aria-label': 'Without label' }}
                            >
                                {
                                    localStateSecondaryCategoriesFromSelectedMainCategory?.map((secondaryCategory: IShelvesCategoryTreeChildDto) => {
                                        if(allSearchParams.isCaptive === "true"){
                                            if(secondaryCategory.isSelected){
                                                return (
                                                    <MenuItem dir={isHebrewStyle ? 'rtl' : 'ltr'}
                                                              key={secondaryCategory.id} value={secondaryCategory.id}>
                                                        {secondaryCategory.caption}
                                                    </MenuItem>
                                                )
                                            }
                                        } else {
                                            return (
                                                <MenuItem dir={isHebrewStyle ? 'rtl' : 'ltr'}
                                                          key={secondaryCategory.id} value={secondaryCategory.id}>
                                                    {secondaryCategory.caption}
                                                </MenuItem>
                                            )
                                        }
                                    })
                                }
                            </Select>
                        </ThemeProvider>
                    </CacheProvider>
                }
                {
                    !isHebrewStyle &&
                    <Select
                        // value={_.isEmpty(selectedSecondaryCategory) ? '' : selectedSecondaryCategory.id}
                        value={isEmpty(selectedSecondaryCategory) ? '' : selectedSecondaryCategory.id}
                        onChange={onChangeSecondaryEvent}
                        displayEmpty
                        // dir={settingsForStore?.dir?.toLowerCase() || "ltr"}
                        className={classes.categorySelect}
                        sx={{
                            width: `100%`,
                            height: `32px`,
                            border: `1px solid #888888`,
                            textAlign: 'start',
                            '& legend': {display: 'none'},
                            '& fieldset': {
                                top: 0,
                                border: `none`,
                            },
                            '& > .MuiSelect-select': {
                                padding: `8px`,
                                textAlign: 'start'
                            }
                        }}

                        MenuProps={{
                            MenuListProps: {
                                sx: {
                                    "& .MuiMenuItem-root": {
                                        minHeight: `auto`,
                                        textAlign: 'start',
                                    },
                                    "& .MuiMenuItem-root.Mui-selected": {
                                        backgroundColor: "#7FA2BF66",
                                    },
                                }
                            },

                        }}
                        // disableUnderline
                        // inputProps={{ 'aria-label': 'Without label' }}
                    >
                        {/*{*/}
                        {/*    SECONDARY_CATEGORIES.map((key: any, index: number) => {*/}
                        {/*        return (*/}
                        {/*            <MenuItem key={index} value={key.caption} sx={{height: `auto`, py:`2px`, minHeight: `auto`}}*/}
                        {/*                      classes={{ selected: classes.selected }}*/}
                        {/*            >*/}
                        {/*                {key.caption}*/}
                        {/*            </MenuItem>*/}
                        {/*        )*/}
                        {/*    })*/}
                        {/*}*/}
                        {
                            localStateSecondaryCategoriesFromSelectedMainCategory?.map((secondaryCategory: IShelvesCategoryTreeChildDto) => {
                                if(allSearchParams.isCaptive === "true"){
                                    if(secondaryCategory.isSelected){
                                        return (
                                            <MenuItem dir={isHebrewStyle ? 'rtl' : 'ltr'}
                                                      key={secondaryCategory.id} value={secondaryCategory.id}>
                                                {secondaryCategory.caption}
                                            </MenuItem>
                                        )
                                    }
                                } else {
                                    return (
                                        <MenuItem dir={isHebrewStyle ? 'rtl' : 'ltr'}
                                                  key={secondaryCategory.id} value={secondaryCategory.id}>
                                            {secondaryCategory.caption}
                                        </MenuItem>
                                    )
                                }
                            })
                        }
                    </Select>
                }
            </>

        )
    }
}